
export default {
  SET_CURRENT_TEAM (state, team) {
    state.currentTeam = team
  }
}
